import { render, staticRenderFns } from "./VisualizarInteligenciaCarbono.vue?vue&type=template&id=bbe3eb78&scoped=true&lang=pug"
import script from "./VisualizarInteligenciaCarbono.vue?vue&type=script&lang=js"
export * from "./VisualizarInteligenciaCarbono.vue?vue&type=script&lang=js"
import style0 from "./VisualizarInteligenciaCarbono.vue?vue&type=style&index=0&id=bbe3eb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe3eb78",
  null
  
)

export default component.exports